import { Injectable } from '@angular/core';
import { CorreoPort, ResultadoEnvio } from '../ports/correo.port';
import { CorreoSalidaEntity } from '../models/alertas.model';

const CLAVE_FALLO = 'mml_correo_simular_fallo';

/**
 * "Envío" simulado: el correo queda en la bandeja del MVP. Nunca sale a internet.
 * Fallos simulados para probar reintentos 1/5/15 min (activable o con destinatarios "rebote").
 */
@Injectable({ providedIn: 'root' })
export class OutboxCorreoSimuladoAdapter extends CorreoPort {
  async enviar(correo: CorreoSalidaEntity): Promise<ResultadoEnvio> {
    if (this.fallosSimulados() || correo.para.includes('rebote')) {
      return { ok: false, error: 'Fallo simulado del proveedor (SES no disponible)' };
    }
    return { ok: true, idProveedor: `sim-${correo.id}` };
  }

  simularFallos(activo: boolean): void {
    if (activo) localStorage.setItem(CLAVE_FALLO, '1'); else localStorage.removeItem(CLAVE_FALLO);
  }

  fallosSimulados(): boolean {
    return typeof localStorage !== 'undefined' && localStorage.getItem(CLAVE_FALLO) === '1';
  }
}
